
  import {Component, Vue} from 'vue-property-decorator';
  import AppDialog from '@/modules/Popup/components/AppDialog.vue';
  import {Barrier} from "@/modules/barriers/interfaces/barrier.interface";
  import {httpResource} from "@/resources/http.resource";
  import {isMobile} from "mobile-device-detect";
  import {IAuth} from "@/modules/Auth/interfaces/auth.interface";

  @Component({
    components: {
      AppDialog,
    },
  })
  export default class OpenBarrierPopup extends Vue {
    $refs: any;
    currentPopup = { blockName: 'barriers', dialogName: 'openBarrier' };
    guestName = '';

    selectedCarType = 10107;
    carTypes = [
      { id: 10107, name: 'Такси', },
      { id: 10108, name: 'Доставка', },
      { id: 10109, name: 'Гость', },
    ];

    get payloadPopup() { return this.$store.getters['dialog/getPopupPayload'](this.currentPopup); }
    get userAccess(): IAuth.UserAccess { return this.$store.state.auth.userAccess; }

    async openBarrier() {
      const barrier: Barrier.Entity = this.payloadPopup.barrier;
      let asyncAction = async () => {
        const action = Barrier.Action.GateMake;
        const params: any = {
          command: Barrier.Commands.OpenBarrier,
          cameraId: barrier.camId,
          carTypeId: this.selectedCarType,
        };
        if (this.guestName) params.guestName = this.guestName;
        let success = await httpResource.httpAction({ action, params });
        this.payloadPopup.noticeAction(success);
      };
      await this.$store.dispatch('defaultResourceAction', { asyncAction });
      this.onClose();
    }

    async clearGateSum() {
      const barrier: Barrier.Entity = this.payloadPopup.barrier;
      let asyncAction = async () => {
        const params: any = {
          command: Barrier.Commands.ClearGateSum,
          cameraId: barrier.camId,
          movId: barrier.movId,
        };
        let success = await httpResource.httpAction({ action: Barrier.Action.GateMake, params });
        this.payloadPopup.noticeAction(success);
      };
      await this.$store.dispatch('defaultResourceAction', { asyncAction });
      this.onClose();
    }

    onClose() {
      this.$refs.appDialog.onClose();
    }

  }
